import Navbar from '../components/Navbar';
import React, { useState } from 'react';
import { FaSearch, FaStar, FaCar, FaMotorcycle, FaTruck } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../services/api';
import BottomNav from '../components/BottomNav';

function Search({ onBack, onTabChange, onOpenPackage }) {
  const { token } = useAuth();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [message, setMessage] = useState('');
  const [sortBy, setSortBy] = useState('fecha');

  const handleSearch = async () => {
    if (!from || !to) { setMessage('Indica origen y destino'); return; }
    try {
      const data = await apiFetch(`/travels?from=${from}&to=${to}`, {}, token);
      setResults(data);
      setSearched(true);
      setMessage('');
    } catch {
      setMessage('Error conectando con el servidor');
    }
  };

  const sortedResults = [...results].sort((a, b) => {
    if (sortBy === 'fecha') return new Date(a.departureDate || a.createdAt) - new Date(b.departureDate || b.createdAt);
    if (sortBy === 'aportacion') return (a.pricePerKg || 0) - (b.pricePerKg || 0);
    return 0;
  });

  const getVehicleIcon = (type) => {
    if (type === 'moto') return <FaMotorcycle style={{color: '#f97316'}} />;
    if (type === 'furgoneta') return <FaTruck style={{color: '#f97316'}} />;
    return <FaCar style={{color: '#f97316'}} />;
  };

  const formatTime = (d) => d ? new Date(d).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }) : '--:--';
  const formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    const today = new Date();
    const tomorrow = new Date(); tomorrow.setDate(today.getDate() + 1);
    if (date.toDateString() === today.toDateString()) return 'Hoy';
    if (date.toDateString() === tomorrow.toDateString()) return 'Mañana';
    return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
  };

  return (
    <div className="min-h-screen pb-24" style={{backgroundColor: '#111318'}}>
      <Navbar onOpenPackage={onOpenPackage} />

      <div className="max-w-lg mx-auto px-4 pt-6">
        <div className="mb-6">
          <p style={{color: '#f97316', fontSize: '12px'}} className="mb-0.5">Cada viaje, una oportunidad de ayudar</p>
          <h1 className="text-white font-semibold text-2xl">🚗 ¿Alguien viaja hacia allí?</h1>
        </div>

        {/* Buscador */}
        <div className="rounded-2xl p-4 mb-5" style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}>
          <div className="flex gap-3">
            <div className="flex flex-col flex-1 gap-2">
              <input placeholder="Origen" value={from} onChange={e => setFrom(e.target.value)}
                style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white', borderRadius: '12px', padding: '10px 14px', fontSize: '14px', minWidth: 0}}
                className="focus:outline-none focus:ring-1 focus:ring-orange-500" />
              <input placeholder="Destino" value={to} onChange={e => setTo(e.target.value)}
                style={{backgroundColor: '#111318', border: '1px solid #2a2d35', color: 'white', borderRadius: '12px', padding: '10px 14px', fontSize: '14px', minWidth: 0}}
                className="focus:outline-none focus:ring-1 focus:ring-orange-500" />
            </div>
            <button onClick={handleSearch}
              style={{backgroundColor: '#f97316', borderRadius: '14px', padding: '0 16px'}}
              className="text-white flex items-center justify-center">
              <FaSearch style={{fontSize: '14px'}} />
            </button>
          </div>
          {message && <p className="text-red-400 text-xs mt-3">{message}</p>}
        </div>

        {/* Ordenar */}
        {searched && results.length > 0 && (
          <div className="flex items-center gap-2 mb-4">
            <span className="text-gray-600 text-xs">Ordenar:</span>
            {[{ key: 'fecha', label: 'Fecha' }, { key: 'aportacion', label: 'Aportación' }].map(s => (
              <button key={s.key} onClick={() => setSortBy(s.key)}
                style={sortBy === s.key
                  ? {backgroundColor: '#f97316', color: 'white', fontSize: '11px', fontWeight: '600', padding: '4px 10px', borderRadius: '8px'}
                  : {backgroundColor: '#1a1d24', color: '#6b7280', fontSize: '11px', padding: '4px 10px', borderRadius: '8px', border: '1px solid #2a2d35'}
                }>
                {s.label}
              </button>
            ))}
          </div>
        )}

        {/* Sin resultados */}
        {searched && results.length === 0 && (
          <div className="text-center py-16">
            <div className="text-4xl mb-3 opacity-20">🚗</div>
            <p className="text-gray-500 text-sm font-medium">Nadie viaja por ahí ahora mismo</p>
            <p className="text-gray-600 text-xs mt-1">Vuelve más tarde o prueba otra ruta</p>
          </div>
        )}

        {/* Resultados viajeros */}
        {sortedResults.map(travel => (
          <div key={travel.id}
            style={{backgroundColor: '#1a1d24', border: '1px solid #2a2d35'}}
            className="rounded-2xl p-4 mb-3 hover:border-orange-500 transition duration-200">
            {travel.departureDate && (
              <p style={{color: '#f97316', fontSize: '11px', fontWeight: '600'}} className="mb-3 uppercase tracking-wide">
                {formatDate(travel.departureDate)}
              </p>
            )}
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className="text-center">
                  <p className="text-white font-bold text-lg">{formatTime(travel.departureDate)}</p>
                  <p className="text-gray-500 text-xs">{travel.departurePlace || travel.from}</p>
                </div>
                <div className="flex flex-col items-center gap-1 px-2">
                  <div className="w-12 h-px" style={{backgroundColor: '#2a2d35'}}></div>
                  <div style={{fontSize: '11px'}}>{getVehicleIcon(travel.vehicleType)}</div>
                  <div className="w-12 h-px" style={{backgroundColor: '#2a2d35'}}></div>
                </div>
                <div className="text-center">
                  <p className="text-white font-bold text-lg">{formatTime(travel.arrivalDate)}</p>
                  <p className="text-gray-500 text-xs">{travel.arrivalPlace || travel.to}</p>
                </div>
              </div>
              {travel.pricePerKg && (
                <div className="text-right">
                  <p style={{color: '#f97316'}} className="font-bold text-sm">desde {travel.pricePerKg}€</p>
                  <p className="text-gray-600 text-xs">contrib. por kg</p>
                </div>
              )}
            </div>

            {/* Paradas */}
            {travel.paradas?.length > 0 && (
              <div style={{display:'flex', flexWrap:'wrap', gap:'4px', marginBottom:'10px'}}>
                {travel.paradas.map((p, i) => (
                  <span key={i} style={{backgroundColor:'#f9731615', border:'1px solid #f9731630',
                    color:'#f97316', fontSize:'10px', fontWeight:'600', padding:'2px 8px', borderRadius:'20px'}}>
                    📍 {p}
                  </span>
                ))}
              </div>
            )}

            <div className="flex items-center justify-between pt-3" style={{borderTop: '1px solid #2a2d35'}}>
              <div className="flex items-center gap-2">
                <div style={{width: '30px', height: '30px', borderRadius: '50%', backgroundColor: '#f97316',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 'bold', color: 'white', flexShrink: 0}}>
                  {String(travel.driverId).charAt(0)}
                </div>
                <div>
                  <p className="text-white text-xs font-semibold">Viajero #{travel.driverId}</p>
                  <div className="flex items-center gap-1">
                    <FaStar style={{color: '#f59e0b', fontSize: '9px'}} />
                    <span className="text-gray-500 text-xs">5.0</span>
                  </div>
                </div>
              </div>
              <button style={{backgroundColor: '#f97316', color: 'white', fontSize: '11px', fontWeight: '600', padding: '6px 14px', borderRadius: '10px'}}>
                Contactar
              </button>
            </div>
          </div>
        ))}
      </div>

      <BottomNav active="search" onChange={onTabChange} unreadCount={0} />
    </div>
  );
}

export default Search;